document.addEventListener( 'DOMContentLoaded', function () {
	const mapEl = document.getElementById( 'contacts-map' );
	const apiUrl = window.contactsMapConfig?.apiUrl;

	if ( !mapEl || !apiUrl ) {
		return;
	}

	let marks = [];

	try {
		marks = JSON.parse( mapEl.dataset.mapMarks || '[]' );
	} catch ( error ) {
		console.error( 'contacts-map: invalid marks data', error );
		return;
	}

	if ( !marks.length ) {
		return;
	}

	let isMapInitialized = false;

	const getMarkIconOptions = ( icon ) => {
		const size = isMobile() ? 45 : 55;

		return {
			iconLayout: 'default#image',
			iconImageHref: icon,
			iconImageSize: [ size, size ],
			iconImageOffset: [ -size / 2, -size ],
			hideIconOnBalloonOpen: true,
		};
	};

	const getClustererOptions = () => {
		const clusterColor = '#244190';
		const clusterSize = 44;
		const clusterHalf = clusterSize / 2;

		const clusterIconLayout = ymaps.templateLayoutFactory.createClass(
			`<div style="width:${clusterSize}px;height:${clusterSize}px;margin:-${clusterHalf}px 0 0 -${clusterHalf}px;background:${clusterColor};color:#fff;border-radius:50%;font-weight:700;font-size:14px;line-height:${clusterSize}px;text-align:center;box-sizing:border-box;">$[properties.geoObjects.length]</div>`
		);

		return {
			groupByCoordinates: false,
			clusterDisableClickZoom: false,
			clusterHideIconOnBalloonOpen: true,
			geoObjectHideIconOnBalloonOpen: true,
			clusterIconLayout: clusterIconLayout,
			clusterIconShape: {
				type: 'Circle',
				coordinates: [ 0, 0 ],
				radius: clusterHalf,
			},
		};
	};

	const initMap = () => {
		if ( isMapInitialized || typeof ymaps === 'undefined' ) {
			return;
		}

		isMapInitialized = true;

		ymaps.ready( function () {
			const map = new ymaps.Map(
				mapEl,
				{
					center: marks[0].coords,
					zoom: marks.length === 1 ? 16 : 10,
					controls: [ 'zoomControl', 'fullscreenControl' ],
				},
				{
					suppressMapOpenBlock: true,
				}
			);

			const placemarks = marks.map( function ( mark ) {
				const options = mark.icon
					? getMarkIconOptions( mark.icon )
					: { hideIconOnBalloonOpen: true };

				return new ymaps.Placemark(
					mark.coords,
					{
						balloonContent: mark.balloon || '',
					},
					options
				);
			} );

			const clusterer = new ymaps.Clusterer( getClustererOptions() );

			clusterer.add( placemarks );
			map.geoObjects.add( clusterer );

			if ( marks.length > 1 ) {
				map.setBounds( clusterer.getBounds(), {
					checkZoomRange: true,
					zoomMargin: 40,
				} );
			}
		} );
	};

	const loadYandexMaps = () => {
		return new Promise( function ( resolve, reject ) {
			if ( typeof ymaps !== 'undefined' ) {
				resolve();
				return;
			}

			const existingScript = document.querySelector( 'script[data-contacts-map-api]' );

			if ( existingScript ) {
				existingScript.addEventListener( 'load', resolve, { once: true } );
				existingScript.addEventListener( 'error', reject, { once: true } );
				return;
			}

			const script = document.createElement( 'script' );
			script.src = apiUrl;
			script.async = true;
			script.dataset.contactsMapApi = 'true';
			script.onload = resolve;
			script.onerror = reject;
			document.head.appendChild( script );
		} );
	};

	const loadAndInitMap = () => {
		loadYandexMaps()
			.then( initMap )
			.catch( function ( error ) {
				console.error( 'contacts-map: failed to load Yandex Maps', error );
			} );
	};

	if ( !('IntersectionObserver' in window) ) {
		loadAndInitMap();
		return;
	}

	const mapObserver = new IntersectionObserver(
		function ( entries ) {
			entries.forEach( function ( entry ) {
				if ( !entry.isIntersecting ) {
					return;
				}

				mapObserver.disconnect();
				loadAndInitMap();
			} );
		},
		{
			rootMargin: '300px 0px',
			threshold: 0,
		}
	);

	mapObserver.observe( mapEl );
} );
